// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import CounselingDirectionPage from "../pages/CounselingDirection/CounselingDirection";
const __wvcRoutePaths = ["/CounselingDirectionPage", "/\u30AB\u30A6\u30F3\u30BB\u30EA\u30F3\u30B0\u306E\u65B9\u5411\u6027"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["aboutpage", "blogpage", "consultationservices", "counselingdirectionpage", "counselingflowpage", "counselingtechniquespage", "coupleconsultationpage", "developmentconsultationpage", "frequentlyaskedquestionspage", "homepage", "menupage", "post", "privacypolicypage", "psychologicalcounselingpage", "reservationinquirypage", "workplacerelationsconsultationpage", "\u304a\u5b50\u3055\u3093\u306e\u767a\u9054\u3068\u5b50\u80b2\u3066\u306e\u3054\u76f8\u8ac7", "\u3054\u4e88\u7d04\u30fb\u304a\u554f\u3044\u5408\u308f\u305b", "\u3054\u76f8\u8ac7\u5185\u5bb9", "\u3088\u304f\u3042\u308b\u3054\u8cea\u554f", "\u30ab\u30a6\u30f3\u30bb\u30ea\u30f3\u30b0\u306e\u65b9\u5411\u6027", "\u30ab\u30a6\u30f3\u30bb\u30ea\u30f3\u30b0\u306e\u6d41\u308c", "\u30ab\u30a6\u30f3\u30bb\u30ea\u30f3\u30b0\u30e1\u30cb\u30e5\u30fc", "\u30ab\u30a6\u30f3\u30bb\u30ea\u30f3\u30b0\u6280\u6cd5", "\u30d6\u30ed\u30b0", "\u30d7\u30e9\u30a4\u30d0\u30b7\u30fc\u30dd\u30ea\u30b7\u30fc", "\u30db\u30fc\u30e0", "\u592b\u5a66\u30fb\u30d1\u30fc\u30c8\u30ca\u30fc\u95a2\u4fc2\u306e\u3054\u76f8\u8ac7", "\u5fc3\u7406\u30ab\u30a6\u30f3\u30bb\u30ea\u30f3\u30b0\u3068\u306f", "\u76f8\u8ac7\u5ba4\u7d39\u4ecb", "\u8077\u5834-\u4eba\u9593\u95a2\u4fc2\u306e\u76f8\u8ac7"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<CounselingDirectionPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<CounselingDirectionPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
